import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 
    "previewTitle", "previewLabel", "previewImage",
    "title", "label", "backgroundImage" ];

  connect() {
    this.preview();
  }

  preview() {
    this.imagePreview()
    this.previewLabelTarget.innerHTML = this.labelTarget.value
    this.previewTitleTarget.innerHTML = this.titleTarget.value
  }

  imagePreview() {
    const input = this.backgroundImageTarget;
    const output = this.previewImageTarget;
    if (input.files && input.files[0]) {
      const reader = new FileReader();

      reader.onload = function () {
        output.src = reader.result
      }

     reader.readAsDataURL(input.files[0]);
    }
  }
}
